import { Link } from "react-router-dom";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";

const SECTIONS = [
  {
    id: "who-we-are",
    title: "1 · Who we are",
    body: [
      "NormShift is a multi-framework governance, risk and compliance (GRC) product. This Privacy Policy explains what personal data we collect on this website (normshift.in / normshift.io / their subdomains), how we use it, who we share it with, and the choices you have.",
      "For any question about this Policy, or to exercise your rights, write to daksh@normshift.in. Postal address: NormShift, Mumbai, India.",
    ],
  },
  {
    id: "what-we-collect",
    title: "2 · What we collect on this website",
    body: [
      "Demo-request form: name, work email, company, frameworks you're pursuing, and any message you send us.",
      "Basic technical data: IP address, browser and device information, referring URL, and pages visited. This is collected via lightweight analytics (PostHog) so we can understand which parts of the site work and which don't.",
      "Cookies: we use only strictly-necessary and analytics cookies. No advertising or cross-site tracking.",
    ],
  },
  {
    id: "why-we-collect",
    title: "3 · Why we collect it (legal bases)",
    body: [
      "To respond to your demo request and schedule a walkthrough (contract / your explicit consent).",
      "To improve the product website and detect abuse (our legitimate interest, balanced against your rights).",
      "To comply with our legal obligations under Indian law (including the Digital Personal Data Protection Act, 2023) and, where applicable, GDPR.",
    ],
  },
  {
    id: "sharing",
    title: "4 · Who we share it with",
    body: [
      "We do not sell your data. Ever.",
      "We use a small number of processors under contract: our lead-capture provider (Web3Forms) for form email delivery, PostHog for privacy-preserving analytics, and MongoDB Atlas for storing demo requests.",
      "We may disclose data if legally compelled by a competent authority, and only after we verify the request.",
    ],
  },
  {
    id: "retention",
    title: "5 · How long we keep it",
    body: [
      "Demo-request records are retained for up to 24 months from your last interaction, then deleted or anonymised. Analytics data is retained for up to 12 months.",
      "You can ask us to delete your data earlier — see 'Your rights' below.",
    ],
  },
  {
    id: "location",
    title: "6 · Where it lives",
    body: [
      "Demo-request data is hosted in India (Mumbai region) on MongoDB Atlas. Analytics is processed in the United States by PostHog Inc. Web3Forms operates from the United States. We rely on Standard Contractual Clauses and our processors' security programs for cross-border transfers.",
    ],
  },
  {
    id: "rights",
    title: "7 · Your rights",
    body: [
      "Under India's DPDP Act you can request access to, correction of, erasure of, or the withdrawal of consent for your personal data. Under GDPR (if you are in the EEA/UK) you additionally have the rights to portability, restriction, and objection.",
      "Write to daksh@normshift.in from the email address associated with your data. We reply within 30 days.",
      "You may also complain to a Data Protection Authority — for India, the Data Protection Board; for the EEA, your national supervisory authority.",
    ],
  },
  {
    id: "security",
    title: "8 · Security",
    body: [
      "We use encryption in transit (TLS 1.2+) and at rest. Access to production systems is behind SSO + MFA and least-privilege roles. All admin actions are recorded in a hash-chained audit log we can independently verify. If a breach affects your data, we will notify you and the Data Protection Board within the timelines required by law.",
    ],
  },
  {
    id: "children",
    title: "9 · Children",
    body: [
      "This website is intended for business use. We do not knowingly collect personal data from anyone under 18. If you believe we have, write to us and we'll delete it.",
    ],
  },
  {
    id: "changes",
    title: "10 · Changes to this Policy",
    body: [
      "If we update this Policy, we will change the 'Last updated' date below and, for material changes, notify people who have contacted us. The current version always lives at /privacy.",
    ],
  },
];

export default function PrivacyPage() {
  return (
    <div className="App grain">
      <Nav />
      <main className="pt-32 md:pt-40 pb-24">
        <div className="mx-auto max-w-[900px] px-6 md:px-10">
          <div className="flex items-center gap-3 mb-6 font-mono text-[11px] tracking-[0.24em] uppercase text-ink-muted">
            <Link to="/" className="hover:text-white transition-colors" data-testid="privacy-back">← back</Link>
            <span className="h-px flex-1 bg-white/10" />
            <span>Legal · Privacy Policy</span>
          </div>

          <h1 className="font-display text-[42px] md:text-[64px] leading-[1.02] tracking-[-0.022em] text-balance">
            Privacy <span className="grad-text">Policy</span>.
          </h1>
          <p className="mt-5 text-ink-muted text-[15px] leading-relaxed max-w-[62ch]">
            Plain-English summary: we collect only what we need to reply to your demo request and understand how this site works.
            We don't sell data. You can ask us to delete yours any time. Details below.
          </p>
          <div className="mt-5 font-mono text-[11px] tabular text-white/50">
            Last updated · 14 December 2026 · v1.0
          </div>

          <div className="mt-12 space-y-10 hairline-t pt-10">
            {SECTIONS.map((s) => (
              <section key={s.id} id={s.id}>
                <h2 className="font-display text-[22px] md:text-[26px] tracking-[-0.015em] mb-4">{s.title}</h2>
                <div className="space-y-3 text-[14.5px] leading-relaxed text-white/80 max-w-[68ch]">
                  {s.body.map((p, i) => (<p key={i}>{p}</p>))}
                </div>
              </section>
            ))}
          </div>

          <div className="mt-16 machined p-6">
            <div className="font-mono text-[10px] tracking-[0.22em] uppercase text-ink-muted">Contact · privacy</div>
            <div className="mt-3 text-[14.5px] text-white/90">
              <a href="mailto:daksh@normshift.in" className="text-white hover:underline underline-offset-4">daksh@normshift.in</a> · Mumbai, India
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
